import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { useLazyQuery } from '@grandvisionhq/graphql';
import { useIntl } from '@grandvisionhq/state';
import '../../queries/get-appointment-by-token.js';
import '../../queries/get-appointment-by-id.js';
import { GET_STORE_BY_CODE } from '../../queries/get-store-by-code.js';
import '../../queries/reschedule-appointment-by-id.js';
import '../../queries/reschedule-appointment-by-token.js';
import { fromStoreQueryToStore } from './adapters/fromStoreQueryToStore.js';

const useStoreByCode = (variables)=>{
    const { locale  } = useIntl();
    const [query, queryState] = useLazyQuery(GET_STORE_BY_CODE, {
        variables,
        context: {
            forwardHeaders: {
                'Accept-Language': locale
            }
        }
    });
    const data = React.useMemo(()=>{
        var ref;
        return ((ref = queryState.data) === null || ref === void 0 ? void 0 : ref.store) ? fromStoreQueryToStore(queryState.data.store) : null;
    }, [
        queryState
    ]);
    return React.useMemo(()=>[
            query,
            swcHelpers.objectSpread({}, queryState, {
                data
            }), 
        ]
    , [
        data,
        queryState,
        query
    ]);
};

export { useStoreByCode as default };
//# sourceMappingURL=use-store-by-code.js.map
